<!--suppress JSUnresolvedReference -->
@if (luser | async; as user) {
  @if (user | hasEitherPerm: ["cauth.view_user"]) {
    <div class="top-menu mx-2">
      <tui-hosted-dropdown [tuiDropdownMaxHeight]="700" [content]="umenu">
        <tui-svg [src]="'mat::eye'" class="tm-icon"></tui-svg>
      </tui-hosted-dropdown>
    </div>

    <ng-template #umenu>
      <tui-data-list role="menu">
        <tui-opt-group>
          @if (user | hasAllPerms: ["cauth.view_user"]) {
            <a class="m-option" tuiOption routerLink="/users">
              <div class="d-flex align-items-center">
                <div class="m-option-icon">
                  <tui-svg [src]="'tuiIconUserLarge'"></tui-svg>
                </div>
                <div class="m-option-text mx-3" i18n>Users</div>
              </div>
            </a>
          }
          @if (user | hasAllPerms: ["core.view_company"]) {
            <a class="m-option" tuiOption routerLink="/companies">
              <div class="d-flex align-items-center">
                <div class="m-option-icon">
                  <tui-svg [src]="'mat::company'"></tui-svg>
                </div>
                <div class="m-option-text mx-3" i18n>Companies</div>
              </div>
            </a>
          }
          @if (user | hasAllPerms: ["core.view_rfidtag"]) {
            <a class="m-option" tuiOption routerLink="/rfid-tags">
              <div class="d-flex align-items-center">
                <div class="m-option-icon">
                  <tui-svg [src]="'mat::rfid'"></tui-svg>
                </div>
                <div class="m-option-text mx-3" i18n>Tags</div>
              </div>
            </a>
          }
          @if (user | hasAllPerms: ["core.view_assetcategory"]) {
            <a class="m-option" tuiOption routerLink="/categories">
              <div class="d-flex align-items-center">
                <div class="m-option-icon">
                  <tui-svg [src]="'mat::categories'"></tui-svg>
                </div>
                <div class="m-option-text mx-3" i18n>Categories</div>
              </div>
            </a>
          }
          @if (user | hasAllPerms: ["core.view_asset"]) {
            <a class="m-option" tuiOption routerLink="/assets">
              <div class="d-flex align-items-center">
                <div class="m-option-icon">
                  <tui-svg [src]="'mat::asset'"></tui-svg>
                </div>
                <div class="m-option-text mx-3" i18n>Assets</div>
              </div>
            </a>
          }
          <a class="m-option" tuiOption routerLink="/scans">
            <div class="d-flex align-items-center">
              <div class="m-option-icon">
                <tui-svg [src]="'mat::scan'"></tui-svg>
              </div>
              <div class="m-option-text mx-3" i18n>Scans</div>
            </div>
          </a>
          @if (user | hasAllPerms: ["core.view_location"]) {
            <a class="m-option" tuiOption routerLink="/locations">
              <div class="d-flex align-items-center">
                <div class="m-option-icon">
                  <tui-svg [src]="'mat::location'"></tui-svg>
                </div>
                <div class="m-option-text mx-3" i18n>Locations</div>
              </div>
            </a>
          }
          @if (user | hasAllPerms: ["core.view_person"]) {
            <a class="m-option" tuiOption routerLink="/persons">
              <div class="d-flex align-items-center">
                <div class="m-option-icon">
                  <tui-svg [src]="'mat::person'"></tui-svg>
                </div>
                <div class="m-option-text mx-3" i18n>Persons</div>
              </div>
            </a>
          }
          @if (user | hasAllPerms: ["core.view_project"]) {
            <a class="m-option" tuiOption routerLink="/projects">
              <div class="d-flex align-items-center">
                <div class="m-option-icon">
                  <tui-svg [src]="'mat::project'"></tui-svg>
                </div>
                <div class="m-option-text mx-3" i18n>Projects</div>
              </div>
            </a>
          }
          @if (user | hasAllPerms: ["core.access_settings"]) {
            <a class="m-option" tuiOption routerLink="/settings">
              <div class="d-flex align-items-center">
                <div class="m-option-icon">
                  <tui-svg [src]="'mat::settings'"></tui-svg>
                </div>
                <div class="m-option-text mx-3" i18n>Settings</div>
              </div>
            </a>
          }
        </tui-opt-group>
      </tui-data-list>
    </ng-template>
  }
}
